import { ReactComponent } from "./close-small-line.svg";

interface Props {
  fill?: string;
  width?: string;
  height?: string;
}

const CloseSmallLineIcon: React.FC<Props> = (props) => (
  <ReactComponent {...props} />
);

export default CloseSmallLineIcon;
